var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilteri({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "url(#pattern0_3080_19179)",
    stroke: "#8F8F8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6057 14.9228C29.6057 15.4325 29.1925 15.8456 28.6829 15.8456H13.9228C13.4132 15.8456 13 15.4325 13 14.9228C13 14.4132 13.4132 14 13.9228 14H28.6829C29.1925 14 29.6057 14.4132 29.6057 14.9228Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7599 19.4267C27.7599 19.9364 27.3467 20.3496 26.8371 20.3496H15.7666C15.2569 20.3496 14.8438 19.9364 14.8438 19.4267C14.8438 18.9171 15.2569 18.5039 15.7666 18.5039H26.8371C27.3467 18.5039 27.7599 18.9171 27.7599 19.4267Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6133 23.9287C17.6133 24.4383 18.0264 24.8515 18.5361 24.8515H24.0714C24.581 24.8515 24.9942 24.4383 24.9942 23.9287C24.9942 23.419 24.581 23.0059 24.0714 23.0059H18.5361C18.0264 23.0059 17.6133 23.419 17.6133 23.9287Z",
    fill: "#8F8F8F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3080_19179",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3080_19179",
    transform: "scale(0.0125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3080_19179",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANhSURBVHgB7Z29ThtBFIVnt6FDNHRIWURHE9LRmTR0SESij8QLBJ4g5gkIL4BIQYcUJDqa4I4uTkOHspHoKGLRucG5ZzxDBmcxa5/Oez5pmF2zIO2nOz/r4mzmanJ4eLjw+Pi4ned5y07XrBXWFtxs0LNWWuvaPXbsHs/39/d7df4we+0CE1cMBoO9LMs+utkRVocTawcmshx30YsCUXHWfba2Fz9bWlpyKysrvp+fn3dzc3NuFuj3++7+/t6329tbd3d3l/76ixuKrKzISoGoOuu+u+Ewdaurq259fd1LawIPDw/u+vra3dzcxI9Ka++rqvE/gSYP89s3awWEbW1tucXFRddEIPLs7Mz3bijxg0nsptc8E5hWHqqu1WrNzDCdFgzvy8tLP7RdRSU+CQxz3g9rBeY5VJ74BySGIV1aexfnxDy5BguGH7abm5tOPAejMawBhRu68vgKDEP3F453d3cbs1hMClbp09PTeLqMoewr0PZ5bfSY9yTvZbCYwhHA3hh9Fua+PzhR9b0OVuTj42McYg5czvF4hrO4ORbjgSO4MoaPtvaItoEzrLyiHtEVvheAwLc4aepmeRpCBYI1LCIFjiSwPslUV0Cg/4al6U8ck5C4WsidoJBAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJJFAEgkkkUASCSSRQBIJJIFAH2GEjChRj8RVDwJLHIWEMlEDJBgFynwwGPzE0UjooBhDIrALgVc4CvFuogaJK+St5ud20EMFahi/Dhwlo/U8Rw6eVeFXnCH2UowncXQCd34bk2UZglZ9wGAyvsUIqL4kV/UAP7xA5OBZFR7h+OLiQluaCuAEeaqBoxgD+rSRtipsW1fCcqfTceI5iABNwmjb8fMXQ2iRUIYoUIXQ9n1BJfmp1SG0kdEY5J2dncbmCmI9wJRWOwY5oiBuIog7gmhQZKva3Pgpfhaj4BGVhzZLUfBxf1cRBY/FtT1RFHxKeBlBO7yMoCn4vTG2d1O/jGCUEFa7bf94w/o1++dv3Ay9DsPu67f1XbuvK+trvw7jL6ZpW0kGV+B7AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilteri);
export default __webpack_public_path__ + "static/media/filteri.715f2dbc62f12b7b9e9bbf36b2ada36e.svg";
export { ForwardRef as ReactComponent };